var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(EventsEndpoint, _AbstractEndpoint);

  function EventsEndpoint(client) {
    var _this;

    _classCallCheck(this, EventsEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EventsEndpoint).call(this, client));
    _this.url = '/v1/event_details.json';
    _this.cacheTime = 24 * 60 * 60;
    return _this;
  }

  _createClass(EventsEndpoint, [{
    key: "all",
    value: function all() {
      return _get(_getPrototypeOf(EventsEndpoint.prototype), "get", this).call(this).then(transformV1Format);
    }
  }, {
    key: "get",
    value: function get(id) {
      return _get(_getPrototypeOf(EventsEndpoint.prototype), "get", this).call(this, "?event_id=".concat(id), true).then(function (json) {
        return transformV1Format(json)[0];
      });
    }
  }]);

  return EventsEndpoint;
}(AbstractEndpoint);

function transformV1Format(json) {
  var events = json.events;
  var transformed = [];
  var keys = Object.keys(events);

  for (var i = 0; i !== keys.length; i++) {
    transformed.push(Object.assign({
      id: keys[i]
    }, events[keys[i]]));
  }

  return transformed;
}